import "../../../../content/projects/psb/psb.css";
import * as React from 'react';
export default {
  React
};